/* eslint-disable no-console */

import bugsnag from "@bugsnag/js";
import { currentUser } from "lib/currentUser";
import { isEmpty } from "lodash";

// A wrapper around bugsnag.
//
// If you want to track errors on a particular page, you should
// import this module and call ErrorTrack.start() during the page
// object initialization.
//
// Calling ErrorTrack.start() will automatically capture a lot of
// interesting stuff.
//
// See https://docs.bugsnag.com/platforms/browsers/js/
//

export class CustomLogger {
  static debug(message) {
    if (process.env.NODE_ENV === "development") {
      console.debug(`[bugsnag] ${message}`);
    }
  }

  static error(message) {
    console.error(`[bugsnag] ${message}`);
  }

  static info(message) {
    console.info(`[bugsnag] ${message}`);
  }

  static warn(message) {
    console.warn(`[bugsnag] ${message}`);
  }
}

export default class ErrorTrack {
  static start() {
    const configuration = { ...TC.bugsnagConfig, ...{ logger: CustomLogger } };

    try {
      this.bugsnagClient = bugsnag(configuration);
    } catch (e) {
      console.warn("Bugsnag failed to start. Bad configuration?");
    }
  }

  /**
   * @param exception
   * @param {Object} details
   */
  static async notify(exception, details = {}) {
    if (this.bugsnagClient) {
      const options = {};

      // Set current user info
      this.bugsnagClient.user = await currentUser();

      if (!isEmpty(details)) {
        options.metaData = { custom: details };
      }

      this.bugsnagClient.notify(exception, options);
    } else {
      console.warn("Bugsnag client not initialized! Call ErrorTrack.start() first.");
    }
  }
}
